var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250.7 267.4",
    style: {
      enableBackground: "new 0 0 250.7 267.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0DBAE3;}\n\t.st1{fill:#2E3136;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,217.6c58.6,19.9,117,19.9,175.6,0.2c-0.8,0.9-1.6,1.8-2.5,2.6c-11.5,9.9-23.4,15.8-35.5,20 c-19,6.6-38.1,9-57.2,7.9c-24.2-1.3-48.2-6.7-71.5-22.8c-2.5-1.7-4.9-3.9-7.3-5.9C37.9,219,37.4,218.2,36.8,217.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.1,191c-30.7-5.3-44.1-18.4-47.6-48.7c-2.3-19.5-1.4-39.6,0.4-59.2c2.3-25.3,17.5-40.9,42.6-45.7 c42.2-8.1,84.6-8.1,126.7-0.1c25.5,4.8,40.7,20.6,43,46.5c1.6,18.7,2.7,37.8,0.6,56.3c-3.8,33.7-20.5,48.7-55.5,52.5 C159.1,194.5,85.3,194.3,66.1,191z M157.5,176.7c4.3-0.1,8.6-1.1,12.8-1.9c19.8-3.7,30.7-13.4,32.1-32.4c1.4-19,1.4-38.3,0-57.3 c-1.3-18.2-10.7-27.9-29.2-31.4c-32.3-6.1-64.8-6.1-97,0.1c-18.2,3.5-27.4,13.4-28.8,31.8c-1.3,18-1.5,36.3-0.2,54.3 c1.5,21.3,11.7,31.6,32.8,34.8C94.7,176.9,146.5,176.9,157.5,176.7z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible",
      opacity: 0.22
    },
    width: 443,
    height: 358,
    xlinkHref: "../Downloads/image (3).png",
    transform: "matrix(0.75 0 0 0.75 -23.8276 -16.8016)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComo);
export default __webpack_public_path__ + "static/media/como.9479e4e52a5bd112be006731ce3bdd89.svg";
export { ForwardRef as ReactComponent };